/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Input } from "../../../../components/ui/input";
import { Button } from "../../../../components/ui/button";
import SingleSelect from "../../../../components/SelectField/SingleSelect";

const CreateClientTask = (props) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [taskData, setTaskData] = useState({interval: "30"});
  const [taskDataError, setTaskDataError] = useState({});
  const isDark = localStorage?.getItem('darkMode') === 'true';

  const intervalOptions = [
    {label:"28 Days", value:"28"},
    {label:"30 Days", value:"30"},
    {label:"31 Days", value:"31"},
  ]
  
  const handleInputChange = (event) => {
    const {
      target: { name, value },
    } = event;
    setTaskData({ ...taskData, [name]: value });
    setTaskDataError({ ...taskDataError, [name]: "" });
  };
  const handleInputDateChange = (name, newDate) => {
    if (newDate && newDate.isValid && newDate.isValid()) {
      let newDateF = dayjs(newDate).format("MM/DD/YYYY");
      setTaskData({ ...taskData, [name]: newDateF });
      setTaskDataError({ ...taskDataError, [name]: "" });
    } else {
      setTaskData({ ...taskData, [name]: "" });
    }
  };

  const initEditData = (Task) => {
    setTaskData({
      title: Task?.title,
      startDate: Task?.startDate,
      endDate: Task?.endDate,
      frequency: props?.frequency,
      interval: Task?.interval || "30Days",
    });
  };

  useEffect(() => {
    if (
      props?.Task &&
      typeof props?.Task?.taskId !== "undefined" &&
      props?.Task?.taskId !== ""
    ) {
      setIsEditMode(true);
      initEditData(props?.Task);
    }
  }, [props?.Task, props?.Task?.taskId]);

  const validate = () => {
    let valid = true;
    let allErrors = taskDataError;
    if (typeof taskData?.title === "undefined" || taskData?.title === "") {
      valid = false;
      allErrors = { ...allErrors, title: "Task Name is Required" };
    } else {
      allErrors = { ...allErrors, title: "" };
    }
    setTaskDataError(allErrors);
    return valid;
  };

  const onAddTask = () => {
    const data= {
      ...taskData,
      frequency: props?.frequency
    }
    if (true === validate()) {
      if (isEditMode === true) {
        props?.OnEditTask && props?.OnEditTask(props?.Task?.taskId, data);
      } else {
        props?.onCreateNewTask && props?.onCreateNewTask(data);
      }
      setTaskData({});
    }
  };

  const isOpenTasksVariant = /^opentasks(?:(?:\s*-+\s*|)(?:[1-9]|10))?$/i.test(props?.shifttitle);

  return (
    <>
      <div className="stepSectionContent pv-12">
        {isOpenTasksVariant && (
          <>
            <h4
              className="mv-6 color-newBlack dark:text-white"
              style={{ fontSize: "14px", fontWeight: "500" }}
            >
              Add Task Name
            </h4>
            <div className="flex mb-25 mt-10">
              <Input
                name="title"
                id="title"
                placeholder="Enter custom task name"
                onChange={handleInputChange}
                value={taskData?.title ? taskData?.title : ""}
                className="rounded-r-none"
                disabled={!props?.frequency}
              />
              <Button
                className="rounded-l-none"
                disabled={!taskData?.endDate}
                onClick={onAddTask}
              >
                {isEditMode === true ? "Update" : "Add"}
              </Button>
            </div>
          </>
        )}
        {isOpenTasksVariant && (
          <>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div className="newTaskFieldsWrap formFieldwrap mb-20 relative">
                <div className="formFieldwrap taskdescription">
                  <DatePicker
                    label="Start Date"
                    inputFormat="MM/dd/yyyy"
                    mask="__:__ _M"
                    value={
                      taskData?.startDate
                        ? dayjs(taskData.startDate, "MM/DD/YYYY")
                        : null
                    }
                    disabled={!taskData?.title}
                    onChange={(date) =>
                      handleInputDateChange("startDate", date)
                    }
                    // slotProps={{
                    //   popper: { disablePortal: true },
                    // }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        sx: {
                          "& .MuiInputBase-root": {
                            backgroundColor: isDark ? "#1A1F2C" : "white",
                            color: isDark ? "white" : "black",
                          },
                          "& .MuiInputLabel-root": {
                            color: isDark ? "white" : "black",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: isDark ? "gray" : "#ccc",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: isDark ? "white" : "black",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: isDark ? "white" : "#1976d2",
                          },
                        },
                      },
                      popper: {
                        disablePortal: true,
                        sx: {
                          "& .MuiPaper-root": {
                            backgroundColor: isDark ? "#1A1F2C" : "white",
                            color: isDark ? "white" : "black",
                          },
                          "& .MuiDayCalendar-weekDayLabel, & .MuiPickersDay-root":
                            {
                              color: isDark ? "white" : "black",
                            },
                          "& .Mui-selected": {
                            backgroundColor: "#2980ba !important",
                            color: "white !important",
                          },
                          "& .MuiPickersDay-today": {
                            borderColor: "#2980ba",
                          },
                        },
                      },
                    }}
                  />
                  {typeof taskDataError?.startDate !== "undefined" &&
                    taskDataError?.startDate !== "" && (
                      <span className="small error color-danger">
                        {taskDataError?.startDate}
                      </span>
                    )}
                </div>
              </div>

              <div className="newTaskFieldsWrap formFieldwrap mb-20 relative">
                <div className="formFieldwrap taskdescription">
                  <DatePicker
                    label="End Date"
                    inputFormat="MM/dd/yyyy"
                    mask="__:__ _M"
                    value={
                      taskData?.endDate
                        ? dayjs(taskData?.endDate, "MM/DD/YYYY")
                        : null
                    }
                    disabled={!taskData?.startDate}
                    onChange={(date) => handleInputDateChange("endDate", date)}
                    // slotProps={{
                    //   popper: { disablePortal: true },
                    // }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        sx: {
                          "& .MuiInputBase-root": {
                            backgroundColor: isDark ? "#1A1F2C" : "white",
                            color: isDark ? "white" : "black",
                          },
                          "& .MuiInputLabel-root": {
                            color: isDark ? "white" : "black",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: isDark ? "gray" : "#ccc",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: isDark ? "white" : "black",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: isDark ? "white" : "#1976d2",
                          },
                        },
                      },
                      popper: {
                        disablePortal: true,
                        sx: {
                          "& .MuiPaper-root": {
                            backgroundColor: isDark ? "#1A1F2C" : "white",
                            color: isDark ? "white" : "black",
                          },
                          "& .MuiDayCalendar-weekDayLabel, & .MuiPickersDay-root":
                            {
                              color: isDark ? "white" : "black",
                            },
                          "& .Mui-selected": {
                            backgroundColor: "#2980ba !important",
                            color: "white !important",
                          },
                          "& .MuiPickersDay-today": {
                            borderColor: "#2980ba",
                          },
                        },
                      },
                    }}
                  />
                  {typeof taskDataError?.endDate !== "undefined" &&
                    taskDataError?.endDate !== "" && (
                      <span className="small error color-danger">
                        {taskDataError?.endDate}
                      </span>
                    )}
                </div>
              </div>
            </LocalizationProvider>

            <div>
              <SingleSelect
                value={taskData?.interval ? taskData?.interval : ""}
                className={`field`}
                name={"interval"}
                onChange={handleInputChange}
                options={intervalOptions}
              />
            </div>
          </>
        )}
        {!isOpenTasksVariant && (
          <>
            <h4
              className="mv-6 color-newBlack dark:text-white"
              style={{ fontSize: "14px", fontWeight: "500" }}
            >
              Add Task Name
            </h4>
            <div className="flex mt-5">
              <Input
                name="title"
                id="title"
                placeholder="Enter custom task name"
                onChange={handleInputChange}
                value={taskData?.title ? taskData?.title : ""}
                className="rounded-r-none"
                // disabled={!props?.frequency}
              />
              <Button className="rounded-l-none" onClick={onAddTask}>
                {isEditMode === true ? "Update" : "Add"}
              </Button>
            </div>
          </>
        )}
        {/* <div className="newTaskFieldsWrap mt-10 mb-20">
          <div className="mr-10">
            <TextField
              fullWidth={true}
              size="small"
              name="title"
              id="title"
              label="New Task Name"
              variant="outlined"
              placeholder="New Task Name"
              onChange={handleInputChange}
              value={taskData?.title ? taskData?.title : ""}
            />
            {typeof taskDataError?.title !== "undefined" &&
              taskDataError?.title !== "" && (
                <span className="small error color-danger">
                  {taskDataError?.title}
                </span>
              )}
          </div>
          <Button
            variant="contained"
            color="primary"
            className="flatbutton themebutton button-primary buttonblack mr-15"
            onClick={onAddTask}
          >
            {isEditMode === true ? "Update" : "Add"}
          </Button>
        </div> */}
      </div>
    </>
  );
};

export default CreateClientTask;
